import { render, staticRenderFns } from "./CreateOwner.vue?vue&type=template&id=5e6cdda4&scoped=true&"
import script from "./CreateOwner.vue?vue&type=script&lang=js&"
export * from "./CreateOwner.vue?vue&type=script&lang=js&"
import style0 from "./CreateOwner.vue?vue&type=style&index=0&id=5e6cdda4&scoped=true&lang=css&"
import style1 from "./CreateOwner.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e6cdda4",
  null
  
)

export default component.exports